<script lang="ts" setup>
import { ref, onMounted, reactive, onBeforeMount } from 'vue';
import './Login.scss';
import { useToast } from './../../../composables/useToast';
import { useRouter } from 'vue-router';
import autenticacionRepository from '@repositories/autenticacion.repository';
import {
  insertHtmlValidations,
  validateFormat,
} from './../../Ajustes/Usuarios/handleValidator';
import { useI18n } from 'vue-i18n'
import CaptchaCloudflare from './CaptchaCloudflare.vue';

const { t } = useI18n();
const router = useRouter();
const { $toast } = useToast();
const autenticacionController = new autenticacionRepository();

const refForm = ref<any>(null);
const errorMessages = ref<string>('');
const loading = ref<boolean>(false);
const qrCode = ref<string>('');
const token = ref<string>('');
const tokenCaptcha = ref<string | null>(null);
const captchaRef = ref<any>(null);

const handleTokenCaptcha = (captchaToken: string) => {
  tokenCaptcha.value = captchaToken;
};

const handleOnExpired = () => {
  tokenCaptcha.value = null;
};

const passwordValidate: any = reactive({
  containNumber: /.*\d+.*/,
  containUppercase: /[A-Z]/,
  containLowercase: /[a-z]/,
  containSymbol: /.*[\W_].*/,
  minLength: /^.{8,}$/,
});
onBeforeMount(async () => {
  const queryUrl = router.currentRoute.value.query;
  if (queryUrl?.token && typeof queryUrl?.token === 'string') {
    const response = await autenticacionController.verifyToken(queryUrl.token);
    response?.token
      ? (token.value = response.token)
      : router.push({ name: 'Login' });
  } else {
    router.push({ name: 'Login' });
  }
});
onMounted(async () => {
  insertHtmlValidations(passwordValidate);
});

const fieldsUpdatePassword: any = ref([
  {
    key: 'password',
    title: t('autenticacion.recuperar_password.contrasenia'),
    type: 'password',
    validations: {
      rules: {
        required: true,
        min: 8,
        verifyExpreRegular:
          /^(?=.*[!@#$%^&*()_+{}\[\]:;<>,.?~\\-])(?=.*[A-Z])(?=.*[a-z])(?=.*\d).+$/,
      },
    },
    placeholder: 'Ejemplo.123',
    value: null,
    cols: 12,
    customClass: 'inputs-password',
    formatValue: (e: any) => validateFormat(e, passwordValidate),
  },
  {
    key: 'repeatPassword',
    title: t('autenticacion.recuperar_password.repetir_contrasenia'),
    type: 'password',
    validations: {
      rules: {
        required: true,
      },
    },
    placeholder: t('autenticacion.recuperar_password.repetir_contrasenia'),
    value: null,
    cols: 12,
  },
]);

const handleSubmit = async () => {
  const { items, isFormValid } = await refForm.value.getValues();
  if (!isFormValid) return false;
  if (items.password !== items.repeatPassword) {
    return (errorMessages.value = t('autenticacion.recuperar_password.las_contrasenias_no_coinciden'));
  }
  if (!tokenCaptcha.value) {
    return (errorMessages.value = t('autenticacion.login.por_favor_verifica_el_captcha'));
  }

  const response = await autenticacionController.changePassowrd({
    token: token.value,
    password: items.password,
    captchaToken: tokenCaptcha.value,
  });

  captchaRef.value?.reset();

  if (response?.msg == t('autenticacion.recuperar_password.la_contrasenia_fue_actualizada_correctamete')) {
    $toast?.success(t('autenticacion.recuperar_password.contraseña_actualizada'));
    router.push({ name: 'Login' });
  } else {
    $toast?.error(t('global.ocurrio_un_error'));
    router.push({ name: 'Login' });
  }
};
</script>

<template>
  <div class="login-container">
    <div class="login-container__card">
      <div class="login-container__header">
        <div class="login-container__logo-wrap">
          <img
            src="/img/tryger-logo.png"
            alt="Tryger"
            class="login-container__logo"
          />
        </div>
      </div>
      <div class="login-container__content">
        <div class="login-container__firstBox">
          <div class="text-center login-container__title">
            {{ t('autenticacion.recuperar_password.contrasenia') }}
          </div>
        </div>
        <div
          class="d-flex flex-column justify-content-center align-items-center login-container__form"
        >
          <template v-if="errorMessages.length > 0">
            <div class="alert alert-danger">
              {{ errorMessages }}
            </div>
          </template>
          <div v-if="loading">
            <Overlay
              :show="loading"
              :circleColor="'#40a4c6'"
              :borderColor="'#40a4c6'"
            />
          </div>
          <template v-else-if="!qrCode">
            <div class="d-flex justify-content-center">
              <Form :inputs="fieldsUpdatePassword" ref="refForm" />
            </div>
            <div class="login-container__captcha">
              <CaptchaCloudflare
                ref="captchaRef"
                @verified="handleTokenCaptcha"
                @expired="handleOnExpired"
              />
            </div>
            <CButton
              class="py-2 w-100 my-3 mb-4"
              :text="t('autenticacion.recuperar_password.cambiar_contrasenia')"
              :background="`background-blue`"
              :disabled="loading"
              @click="handleSubmit"
              type="button"
            />
          </template>
        </div>
      </div>
    </div>
  </div>
</template>
